import React from 'react';
import styled from '@emotion/styled';
import PageHero from 'components/PageHero';
import { P } from 'components/typography';

const Section = styled.div`
  max-width: ${({ theme }) => theme.width.medium};
  margin: auto;
  padding: 10px;
`;

const StyledP = styled(P)`
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
`;

const Li = styled.li`
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
`;

const OmOss = () => (
  <>
    <PageHero
      title="Om oss"
      text="Digito grundades i början av 2021 med målsättningen en mer hållbar affärsvärld för papper visitkort. Vi lanserade vår första tjänst i maj 2021 och mer kommer!"
    />
    <Section>
      <StyledP>
        Med Digito vill vi ge företagare och andra kreatörer möjligheten att
        hantera och dela sina sociala kanaler under en samlad plattform. En
        plattform som varken intränger på miljön eller går att slänga i en
        papperskorg.
      </StyledP>
      <ul>
        <Li>8-10 miljarder visitkort trycks årligen.</Li>
        <Li>
          88% av alla tryckta visitkort slängs i en papperskorg efter att de
          delats ut. 
        </Li>
        <Li>8 miljoner träd kan räddas årligen.</Li>
      </ul>
      <StyledP>
        Varför inte imponera med ett modernt visitkort på dina framtida möten?
      </StyledP>
      <StyledP>
        Omställning till en hållbar konsumtion och produktion av varor är en
        nödvändighet för att minska vår negativa påverkan på klimat och miljö.
        Därför lyder vårt motto – Vi är inte i mål förrän visitkorten är i
        mobilen istället för papperskorgen. 
      </StyledP>
    </Section>
  </>
);

OmOss.layoutOptions = {
  backgroundColor: '#e9d3b8',
  footer: true,
  noBottomSpacing: true
};

export default OmOss;
